// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from "react";
import { api } from "../utils/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check if user is logged in on mount
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    if (!api.isAuthenticated()) {
      setLoading(false);
      return;
    }

    try {
      const res = await api.getMe();
      if (res.success) {
        setUser(res.data.user);
      } else {
        api.clearAuth();
      }
    } catch (err) {
      api.clearAuth();
    } finally {
      setLoading(false);
    }
  };

  const register = async (data) => {
    setError(null);
    const res = await api.register(data);

    if (res.success) {
      setUser(res.data.user);
      return { success: true };
    }

    setError(res.message);
    return { success: false, message: res.message, errors: res.errors };
  };

  const login = async (data) => {
    setError(null);
    const res = await api.login(data);

    if (res.success) {
      setUser(res.data.user);
      return { success: true };
    }

    setError(res.message);
    return { success: false, message: res.message };
  };

  const logout = async () => {
    await api.logout();
    setUser(null);
    setError(null);
  };

  const value = {
    user,
    loading,
    error,
    register,
    login,
    logout,
    isAuthenticated: !!user,
    isAdmin: user?.role === "admin",
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};